<ng-container *ngIf="scorecard.Locked; else normalScorecard">
  <fgbcl-scorecard-locked
    [disabled]="disabled"
    [isSponsorInBody]="isSponsorInBody"
    [scorecard]="scorecard"
  ></fgbcl-scorecard-locked>
</ng-container>

<ng-template #normalScorecard>
  <ng-container *ngIf="scorecard.ScoreCardDisplayType !== 4">
    <div
      [ngClass]="{ 'scorecard-linked-shadow': scorecard?.ParentId || isScorecardHasChild }"
      class="scorecard scorecard-punchcard scorecard-container col-12 px-0 d-flex flex-column justify-content-between scorecard-container-radius"
      (click)="openScorecardDescription()"
    >
      <!--Header-->
      <div>
        <div class="scorecard-count-container w-100 d-flex justify-content-between">
          <div class="d-flex">
            <img
              alt=""
              class="scorecard-image"
              [ngClass]="{ 'scorecard-one-punch-incomplete': !scorecard.Completed }"
              src="{{ scorecard.Image | contentImage: '7' : 'badge' }}"
              [useDefault]="true"
              [loyaltyType]="'badge'"
            />
            <span class="ps-3">
              <h3 class="scorecard-name scorecard-label-ellipsis" id="scorecard-punchcard-name">
                {{ scorecard.Content[0].Name }}
              </h3>
              <p class="scorecard-description scorecard-label-ellipsis mb-2" id="scorecard-punchcard-description">
                {{ scorecard.Content[0].ShortDescription }}
              </p>
            </span>
          </div>
          <div class="scorecard-punchcard-steps" id="scorecard-punchcard-actions-completed">
            {{ scorecard.ActionsCompleted }}/{{ scorecard.Actions.length }}
          </div>
        </div>
      </div>
      <!--Middle content-->
      <div class="d-flex flex-column action-container">
        <!--Scorecard punches-->
        <div class="d-flex flex-wrap mx-3 punch-spacing">
          <ng-container *ngFor="let action of scorecard.Actions; index as j">
            <div
              class="text-center"
              [ngClass]="{
                'my-3 pb-3 ': scorecard.Actions.length < 5 && scorecard.ScoreCardDisplayType === 5,
                'mb-2 mt-0 ': scorecard.Actions.length <= 5 && scorecard.ScoreCardDisplayType === 0,
                'mb-1': scorecard.Actions.length > 5,
              }"
            >
              <div
                class="action-img-container border rounded-circle mx-auto d-flex"
                [ngClass]="{
                  'border-primary bg-primary punchcard-action-complete': action.ActionCompleted,
                  'border-disabled bg-disabled punchcard-action-incomplete': !action.ActionCompleted,
                }"
              >
                <img
                  alt="{{
                    action.ActionCompleted
                      ? 'scorecard.punchcard.completed'
                      : ('scorecard.punchcard.not.completed'
                        | translate: { punchcardName: action.Content[0]?.Name ? action.Content[0].Name : 'punch' })
                  }}"
                  class=" m-auto"
                  [ngClass]="{
                    'action-img': scorecard.Actions.length > 5,
                    'action-img-lg': scorecard.Actions.length <= 5
                  }"
                  src="{{ action.Image | contentImage: '6' }}"
                  draggable="false"
                />
              </div>
            </div>
            <ng-container *ngIf="scorecard.Actions.length > 5 && j == lineBreakIndex">
              <div class="w-100 my-1"></div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <!--Footer-->
      <div
        class="w-100"
        [ngClass]="{
          'single-line-punchcard-footer': scorecard.Actions.length <= 5 && scorecard.ScorecardCategory !== category.defaultView,
        }"
      >
        <div class="scorecard-footers scorecard-footer-container">
          <div class="scorecard-prize-border">
            <ng-container
              *ngIf="
                scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard?.HasCustomerSelectedPrize;
                else normalFooter
              "
            >
              <span class="scorecard-choose-prize-text" id="scorecard-completed-text">{{
                'scorecard.footer.choose.prize' | translate
              }}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!--One Punch View-->
  <ng-container *ngIf="scorecard.ScoreCardDisplayType === 4">
    <div
      [ngClass]="{ 'scorecard-linked-shadow': scorecard?.ParentId || isScorecardHasChild }"
      class="scorecard scorecard-punchcard scorecard-container col-12 px-0 d-flex flex-column position-relative scorecard-container-radius"
      (click)="openScorecardDescription()"
    >
      <!--Scorecard Primary Background Banner-->
      <div class="scorecard-background-banner position-relative">
        <div class="scorecard-image-one-punch">
          <div class="img-container pt-1 mx-auto rounded-circle">
            <img
              alt=""
              src="{{ scorecard.Image | contentImage: '7' : 'badge' }}"
              [useDefault]="true"
              [loyaltyType]="'badge'"
              [ngClass]="{ 'scorecard-one-punch-incomplete': !scorecard.Completed }"
            />
          </div>
        </div>
      </div>
      <!--Scorecard Description Section-->
      <div class="pt-4 text-center scorecard-solo-action-container">
        <h3
          class="scorecard-label-ellipsis text-capitalize fw-bold font-size-14 one-punchcard-name rounded"
          id="scorecard-name"
          [ngClass]="scorecard.Completed ? 'scorecard-one-punch-complete-name' : 'scorecard-one-punch-incomplete-name'"
        >
          {{ scorecard.Content[0].Name }}
        </h3>
        <p class="mt-1 mb-3 scorecard-label-ellipsis font-size-12" id="scorecard-description">
          {{ scorecard.Content[0].ShortDescription }}
        </p>
        <h4 class="accessibility-only">{{ scorecard.Completed ? 'Completed' : 'Not Completed' }}</h4>
      </div>
      <!--Scorecard Prize Bar-->
      <div class="w-100 onepunch-footer">
        <div class="scorecard-footer-container">
          <div class="scorecard-prize-border">
            <ng-container
              *ngIf="
                scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard?.HasCustomerSelectedPrize;
                else normalFooter
              "
            >
              <span class="scorecard-choose-prize-text" id="scorecard-completed-text">{{
                'scorecard.footer.choose.prize' | translate
              }}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #normalFooter>
    <div class="scorecard-label-ellipsis scorecard-prize">
      <span class="scorecard-prize-label">{{ 'scorecard.prize' | translate }} </span>
      <span class="scorecard-prize-text" id="scorecard-completed-text">{{
        scorecard.Completed && scorecard?.HasCustomerSelectedPrize
          ? ('scorecard.footer.prize.selected' | translate)
          : !scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard.HasCustomerSelectedPrize
            ? ('scorecard.footer.prize.selection' | translate)
            : scorecard.Content[0].PrizeDescription
      }}</span>
    </div>
    <ng-container *ngIf="scorecard.Sponsor?.SponsorImage">
      <div class="sponsor-img-text">
        <img class="sponsor-img" [src]="scorecard.Sponsor.SponsorImage | contentImage: '30'" />
      </div>
    </ng-container>
  </ng-template>
</ng-template>
